/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import AuthLeftSide from "../../components/AuthLeftSide";
import Spin from "../../components/Spin";
import { Formik } from "formik";
import { Label } from "../../components/ui/label";
import { Input } from "../../components/ui/input";
import { Eye, EyeClosedIcon } from "lucide-react";
import { Button } from "../../components/ui/button";
import { ThemeToggle } from "../../components/ThemeToggle";
import CryptoJS from "crypto-js";
import { API, get, IV, post, SECRETKEY } from "../../config";
import { Link, useNavigate } from "react-router-dom";
import { useToast } from "../../components/ui/use-toast";
import { useOrganization } from "../../lib/context/OrganisationContext";
import FaviconSVG from "../../components/FaviconSVG";
import LogoSVG from "../../components/LogoSVG";
import { useUser } from "../../lib/context/UserContext";

const Login = (props) => {
  const [showPassword, setShowPassword] = useState(false);

  const { toast } = useToast();

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const builderId = localStorage.getItem("builderId");

  const userId = localStorage.getItem("userId");
  const EmailVerification = localStorage.getItem("EmailVerification");
  const hasToken = localStorage.getItem("ts-auth-token");
  const defaultEmail = localStorage.getItem("invite-accountingFirmEmail");
  const tokenExpiredEmail = localStorage.getItem("token-expired-email");
  const DefaultURL = localStorage.getItem("DefaultURL");
  const roleType = localStorage.getItem("roleType");

  // const tfaCheck = localStorage.getItem("ts-auth-tfa");

  const iv = IV;
  const key = SECRETKEY;

  const fkey = CryptoJS.enc.Utf8.parse(key);
  const fiv = CryptoJS.enc.Utf8.parse(iv);

  const { updateOrganizationList } = useOrganization();
  const { updateUserData } = useUser();
  const [isSubscribe, setIsSubscribe] = useState();
  const [singleTrust, setSingleTrust] = useState();
  const [singleTrustId, setSingleTrustId] = useState();
  const [isAMLSubscribe, setIsAMLSubscribe] = useState();

  // *API Call for Login, Password Show and Hide - Start
  const handleFormSubmit = async (values) => {
    try {
      if (values?.email?.trim() === "" || values?.password?.trim() === "") {
        toast({
          variant: "destructive",
          description: "Enter valid email and password",
          duration: 3000,
        });
      } else {
        setLoading(true);

        const encPassword = CryptoJS.AES.encrypt(values?.password, fkey, {
          iv: fiv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });
        const finalEncryptedPassword = encPassword.ciphertext.toString(
          CryptoJS.enc.Base64,
        );
        const finalValue = { ...values, password: finalEncryptedPassword };

        const { data } = await post(API.LOGIN, finalValue);
        if (data?.status === 200 && data.access_token !== undefined) {
          const token = data.access_token;
          const refreshToken = data.refresh_token;
          localStorage.setItem(
            "userType",
            data?.userType ? data?.userType : "",
          );
          props.authenticate(token, values.email, data["2fa"], refreshToken);
          setLoading(false);
          (data.role === "Builder" || data.roleType === "Builder") &&
            localStorage.setItem("builderId", data?.builder_id);
          data.roleType === "Builder" &&
            data.role !== "Builder" &&
            localStorage.setItem("builderUserId", data?.builder_user_id);
          if (data["2fa"] === -1) {
            setLoading(true);
            const userDetails = await get(API.GET_USER_PROFILE);
            setLoading(false);
            if (userDetails) {
              updateUserData(userDetails?.data?.data);
            }

            let isSubscribe = userDetails?.data?.subscribed;
            let isAMLSubscribe = 0;
            // if (userDetails?.data?.data?.user_organizations?.length === 1) {
              isAMLSubscribe =
                userDetails?.data?.data?.user_organizations[0]?.organization
                  ?.is_aml_ctf_subscribed;

              setIsAMLSubscribe(
                userDetails?.data?.data?.user_organizations[0]?.organization
                  ?.is_aml_ctf_subscribed,
              );
            // }

            let singleTrust = userDetails?.data?.single_trust;
            let singleTrustId = userDetails?.data?.trust_id;
            setIsSubscribe(isSubscribe);
            setSingleTrust(singleTrust);

            setSingleTrustId(singleTrustId);

            updateOrganizationList(
              userDetails?.data?.data?.user_organizations &&
                userDetails?.data?.data?.user_organizations?.length > 0
                ? userDetails?.data?.data?.user_organizations?.map((item) => {
                    return {
                      ...item?.organization,
                      value: item?.organization?.id
                        ? item?.organization?.id
                        : "",
                      label: item?.organization?.business_name
                        ? item?.organization?.business_name
                        : "",
                    };
                  })
                : [],
            );
            const { first_name, last_name, profile_pic, id } =
              userDetails?.data?.data;
            localStorage.setItem(
              "Name",
              first_name ? `${first_name} ${last_name}` : last_name,
            );
            localStorage.setItem("ProfilePhoto", profile_pic);
            localStorage.setItem("role", data?.role);
            localStorage.setItem("roleType", data?.roleType);
            localStorage.setItem("role-slug", data?.slug);
            localStorage.setItem("userId", id);
            localStorage.setItem("EmailVerification", 1);            

            tokenExpiredEmail === values?.email
              ? navigate(DefaultURL)
              : data.roleType === "Admin"
                ? navigate("/admin-dashboard")
                : isSubscribe === 1 && singleTrust == 1
                  ? navigate(`/trusts/${singleTrustId}/dashboard`)
                  : isAMLSubscribe
                    ? navigate("/aml-ctf?tab=program")
                    : isSubscribe !== undefined && isSubscribe == 0
                      ? navigate("/general-settings?tab=subscription")
                      : navigate("/trusts");
          } else {
            if (data["2fa"] !== null && data["2fa"] !== 0) {
              localStorage.setItem("role", data?.role);
              localStorage.setItem("roleType", data?.roleType);
              navigate("/2fa", { replace: true });
            } else {
              localStorage.setItem("role", data?.role);
              localStorage.setItem("roleType", data?.roleType);
              navigate("/2fa/register", { replace: true });
            }
          }

          window.setTimeout(function () {
            localStorage.removeItem("DefaultURL");
            localStorage.removeItem("token-expired-email");
          }, 9000);
        }
      }
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    EmailVerification === "1" &&
      hasToken &&
      userId &&
      (roleType === "Admin"
        ? navigate("/admin-dashboard")
        : isSubscribe === 1 && singleTrust == 1
          ? navigate(`/trusts/${singleTrustId}/dashboard`)
          : isAMLSubscribe
            ? navigate("/aml-ctf?tab=program")
            : isSubscribe !== undefined && isSubscribe == 0
              ? navigate("/general-settings?tab=subscription")
              : navigate("/trusts"));
  }, [
    navigate,
    EmailVerification,
    userId,
    hasToken,
    builderId,
    roleType,
    singleTrust,
    singleTrustId,
    isSubscribe,
    isAMLSubscribe,
  ]);

  return (
    <div className="w-full lg:grid lg:grid-cols-2 min-h-screen">
      {loading && <Spin full={true} />}
      <AuthLeftSide />
      <div className="flex items-center justify-center lg:h-auto min-h-screen lg:flex-row flex-col">
        <LogoSVG className="lg:hidden fixed top-[15%] !text-webPrimary !fill-webPrimary h-28 w-full" />
        <div className="mx-auto grid w-[350px] gap-6">
          <div className="grid gap-2 text-center">
            <h1 className="text-3xl font-bold">Login</h1>
            <p className="text-balance text-muted-foreground">
              Enter your email below to login to your account
            </p>
          </div>
          <Formik
            initialValues={{
              email: defaultEmail ? defaultEmail : "",
              password: "",
            }}
            validateOnBlur={false}
            validateOnChange={false}
            onKeyPress={(e) => {
              e.which === 13 && e.preventDefault();
            }}
            onSubmit={handleFormSubmit}
          >
            {({ values, errors, handleChange, handleBlur, handleSubmit }) => (
              <form
                onSubmit={handleSubmit}
                className="row needs-validation"
                noValidate
              >
                <div className="grid gap-4">
                  <div className="grid gap-2">
                    <Label htmlFor="email">Email</Label>
                    <Input
                      id="email"
                      name="email"
                      type="email"
                      // placeholder="m@example.com"
                      required
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      autoFocus={true}
                    />
                  </div>
                  <div className="grid gap-2">
                    <div className="flex items-center">
                      <Label htmlFor="password">Password</Label>
                      <Link
                        to="/forgot-password"
                        className="ml-auto inline-block text-sm underline"
                      >
                        Forgot your password?
                      </Link>
                    </div>
                    <div className="relative">
                      <Input
                        id="password"
                        name="password"
                        type={showPassword ? "text" : "password"}
                        required
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.password}
                      />
                      {showPassword ? (
                        <span className="absolute top-2 right-2">
                          <Eye
                            width={20}
                            height={20}
                            onClick={toggleShowPassword}
                          />
                        </span>
                      ) : (
                        <span className="absolute top-2 right-2">
                          <EyeClosedIcon
                            width={20}
                            height={20}
                            onClick={toggleShowPassword}
                          />
                        </span>
                      )}
                    </div>
                  </div>
                  <Button type="submit" className="w-full">
                    Login
                  </Button>
                </div>
              </form>
            )}
          </Formik>
          <div className="mt-4 text-center text-sm">
            Don&apos;t have an account?{" "}
            <Link to="/signup" className="underline">
              Sign up
            </Link>
          </div>
        </div>
        <div className="text-center text-sm place-items-end lg:absolute lg:bottom-4 relative lg:mt-0 mt-4">
          <div className="text-sm peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
            By selecting Login, you agree to our{" "}
            <Link
              to="https://trustsoft.com.au/terms-conditions/"
              className="underline"
              target="_blank"
            >
              Terms of Use
            </Link>{" "}
            and have read and acknowledge our{" "}
            <Link
              to="https://trustsoft.com.au/privacy-policy/"
              className="underline"
              target="_blank"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
        <p className="lg:hidden fixed bottom-0 p-4 text-xs flex items-start gap-1 text-justify">
          <FaviconSVG className="h-5 w-5 !text-webPrimary !fill-webPrimary" />
          <span className="flex-1">
            TrustSoft acknowledges the Traditional Custodians of country
            throughout Australia and their connections to land, sea and
            community. We pay our respect to their Elders past and present and
            extend that respect to all Aboriginal and Torres Strait Islander
            peoples today.
          </span>
        </p>
      </div>
      <div className="fixed top-4 right-4">
        <ThemeToggle />
      </div>
    </div>
  );
};

export default Login;
